import React, {useEffect} from "react";
import { Provider } from "react-redux";
import {
  Route, Switch, BrowserRouter as Router, Redirect, useLocation,
} from "react-router-dom";
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from "react-toasts";
import ReactDOM from "react-dom";
import "./styles/index.sass";
import { StylesProvider } from "@material-ui/core/styles";
import BottomMobileNavigation from "./components/Common/BottomMobileNavigation";

import { Helmet } from "react-helmet";
import {
  ThemeProvider,
} from '@material-ui/core/styles';
import theme from './theme'
import { getToken } from "./utils";
import { store, history } from "./store";
import ProtectedRoute from "./components/ProtectedRoute";
import URLS from "./config/navigation";
import Auth from "./containers/Auth";
import Profile from "./containers/Profile";
import Public from "./containers/Public";
import { config } from "dotenv";

const AppContainer = (props) => {
  const location = useLocation();

  const checkMobileMenu = () =>{
    const token = getToken();
    if(!Object.values(URLS.PUBLIC).includes(location.pathname) && !Object.values(URLS.AUTH).includes(location.pathname)   && token!==null && token !==undefined){
      return true;
    }
    return false;
  }

  return (
    <>
    <StylesProvider injectFirst>
      <div style={{overflow: 'auto', height: '100vh'}}>
        <Switch>
          <ProtectedRoute
            strict
            path={URLS.PUBLIC.ROOT}
            component={Public}
          />

          <ProtectedRoute
            strict
            path={[URLS.PROFILE.ROOT, URLS.SETTINGS.ROOT]}
            component={Profile}
          />
          <Route
              strict
              path={URLS.AUTH.ROOT}
              component={Auth}
          />

        </Switch>
      </div>
      <ToastsContainer position={ToastsContainerPosition.TOP_CENTER} lightBackground store={ToastsStore} />
      {checkMobileMenu() && (<BottomMobileNavigation />) }
      </StylesProvider>
    </>
  );
}

ReactDOM.render(
  <Router history={history}>
    <Provider store={store}>
    <ThemeProvider theme={theme}>
      <AppContainer>
      
      <Helmet>
      { process.env.REACT_APP_ENV === 'production' &&
        <script>
          {!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="HxnvQkfXaHPLTxDG85uqJ1ETNCynetyU";analytics.SNIPPET_VERSION="4.13.2";
          analytics.load("HxnvQkfXaHPLTxDG85uqJ1ETNCynetyU");
          analytics.page();
           }}()}
        </script>
        }
      </Helmet>
      </AppContainer>
      </ThemeProvider>
    </Provider>
  </Router>,
  document.getElementById("root"),
);
